import React, { useState, useEffect, useRef } from 'react';
import {
  Select,
  MenuItem,
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Modal,
  IconButton,
  CircularProgress
} from '@mui/material';
import { Box } from '@mui/material';
import GoogleMapsAutoComplete from '../components/GoogleMapsAutoComplete';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@mui/styles';
import UsersCombo from '../components/UsersCombo';
import { api } from 'common';
import Button from "components/CustomButtons/Button.js";
import { useTranslation } from "react-i18next";
import { BookingModalBody, validateBookingObj } from 'common/sharedFunctions';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkCat } from '../common/sharedFunctions';
import Switch from '@mui/material/Switch';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getPartnerDisplayName, getPartnerFleetId } from '../common/partnerUtils';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 480,
    maxWidth: '95vw',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  inputRtl: {
    "& label": { right: 25, left: "auto" },
    "& legend": { textAlign: "right", marginRight: 18 }
  },
}));

const icons = {
  'paypal':require('../assets/payment-icons/paypal-logo.png').default,
  'braintree':require('../assets/payment-icons/braintree-logo.png').default,
  'stripe':require('../assets/payment-icons/stripe-logo.png').default,
  'paytm':require('../assets/payment-icons/paytm-logo.png').default,
  'payulatam':require('../assets/payment-icons/payulatam-logo.png').default,
  'flutterwave':require('../assets/payment-icons/flutterwave-logo.png').default,
  'paystack':require('../assets/payment-icons/paystack-logo.png').default,
  'securepay':require('../assets/payment-icons/securepay-logo.png').default,
  'payfast':require('../assets/payment-icons/payfast-logo.png').default,
  'liqpay':require('../assets/payment-icons/liqpay-logo.png').default,
  'culqi':require('../assets/payment-icons/culqi-logo.png').default,
  'mercadopago':require('../assets/payment-icons/mercadopago-logo.png').default,
  'squareup':require('../assets/payment-icons/squareup-logo.png').default,
  'wipay':require('../assets/payment-icons/wipay-logo.png').default,
  'test':require('../assets/payment-icons/test-logo.png').default,
  'razorpay':require('../assets/payment-icons/razorpay-logo.png').default,
}

export default function AddBookings(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    GetDateString,
    GetDistance,
    updateBooking,
    updateWalletBalance
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const cartypes = useSelector(state => state.cartypes.cars);
  const estimatedata = useSelector(state => state.estimatedata);
  const bookingdata = useSelector(state => state.bookingdata);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const providers = useSelector(state => state.paymentmethods.providers);
  const activeBookings = useSelector(state => state.bookinglistdata.active);

  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropAddress, setDropAddress] = useState(null);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [users, setUsers] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [userCombo, setUserCombo] = useState(null);
  const [bookingType, setBookingType] = useState('Book Now');
  const rootRef = useRef(null);
  const [tempRoute, setTempRoute] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [assignedDriverUid] = useState('');
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const [walletModalStatus, setWalletModalStatus] = useState(false);
  const { state } = useLocation();
  const partnerFromProps = props.partner;
  const partnerFromState = state && state.partner ? state.partner : null;
  const activePartner = partnerFromProps || partnerFromState;
  const partnerFleetId = getPartnerFleetId(activePartner);
  const partnerDisplayName = getPartnerDisplayName(activePartner, settings) || (activePartner && activePartner.slug) || 'Partner';
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [roundTrip, setRoundTrip] = useState(0);
  const [tripInstructions, setTripInstructions] = useState('');

  // New states for car selection flow
  const [showCarOptions, setShowCarOptions] = useState(false);
  const [carEstimates, setCarEstimates] = useState([]);
  const [loadingPrices, setLoadingPrices] = useState(false);
  const [optionModalStatus, setOptionModalStatus] = useState(false);
  const [estimateModalStatus, setEstimateModalStatus] = useState(false);
  const [pickupConfirmModalStatus, setPickupConfirmModalStatus] = useState(false);
  const [pickupNote, setPickupNote] = useState('');
  const mapRef = useRef(null);

  const [instructionData, setInstructionData] = useState({
    item_value: "",
    deliveryPerson: "",
    deliveryPersonPhone: "",
    pickUpInstructions: "",
    deliveryInstructions: "",
    parcelTypeIndex: 0,
    optionIndex: 0,
    parcelTypeSelected: null,
    optionSelected: null,
    carrySelected: false
  });

  const [payment_mode, setPaymentMode] = useState(0);
  const [radioProps, setRadioProps] = useState([]);
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(GetDateString());

  useEffect(() => {
    if (settings && providers) {
      setSelectedProvider(providers[0]);
      let arr = [{ label: t('wallet'), value: 0, cat: 'wallet' }];
      let val = 0;
      if (!settings.disable_online && providers && providers.length > 0) {
        val++;
        arr.push({ label: t('card'), value: val, cat: 'card' });
      }
      if (!settings.disable_cash) {
        val++;
        arr.push({ label: t('cash'), value: val, cat: 'cash' });
      }
      setRadioProps(arr);
    }
  }, [settings, providers, t]);

  useEffect(() => {
    if (state && state !== null) {
      if (state.carData) {
        let carDetails = state.carData;
        let instObj = { ...instructionData };
        if (Array.isArray(carDetails.parcelTypes)) {
          instObj.parcelTypeSelected = carDetails.parcelTypes[0];
          instObj.parcelTypeIndex = 0;
        }
        if (Array.isArray(carDetails.options)) {
          instObj.optionSelected = carDetails.options[0];
          instObj.optionIndex = 0;
        }
        setInstructionData(instObj);
        setSelectedCarDetails(carDetails);
      }
      if (state.pickup) setPickupAddress(state.pickup);
      if (state.drop) setDropAddress(state.drop);
    }
  }, [instructionData, state]);

  useEffect(() => {
    if (userdata.users) {
      let arr = [];
      let arrDrivers = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        const matchesPartner = partnerFleetId ? user.fleetadmin === partnerFleetId : true;
        if (user.usertype === 'customer' && matchesPartner && ((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin')) {
          arr.push({
            firstName: user.firstName,
            lastName: user.lastName,
            mobile: user.mobile,
            email: user.email,
            uid: user.id,
            desc: user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin ? user.email : "Hidden"),
            pushToken: user.pushToken
          });
        }
        if (user.usertype === 'driver' && user.approved && !user.queue && user.driverActiveStatus && user.location) {
          if (matchesPartner && ((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin' || auth.profile.usertype === 'customer')) {
            arrDrivers.push({
              uid: user.id,
              location: user.location,
              carType: user.carType,
              firstName: user.firstName,
              lastName: user.lastName
            });
          }
        }
      }
      setUsers(arr);
      setDrivers(arrDrivers);
    }
  }, [userdata.users, settings.AllowCriticalEditsAdmin, auth.profile.usertype, auth.profile.uid, partnerFleetId]);

  useEffect(() => {
    if (auth.profile.usertype && auth.profile.usertype === 'customer') {
      setUserCombo({
        firstName: auth.profile.firstName,
        lastName: auth.profile.lastName,
        mobile: auth.profile.mobile,
        email: auth.profile.email,
        uid: auth.profile.uid,
        pushToken: auth.profile.pushToken
      });
    }
  }, [auth.profile]);

  useEffect(() => {
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'PAYMENT_PENDING') {
      if (bookingdata.booking.mainData.payment_mode === 'cash') {
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings');
      } else {
        if (bookingdata.booking.mainData.payment_mode === 'card') {
          setPaymentModalStatus(true);
        } else {
          setWalletModalStatus(true);
        }
      }
    }
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'NEW') {
      dispatch(clearBooking());
      setTempRoute(null);
      navigate('/bookings');
    }
  }, [bookingdata.booking, clearBooking, dispatch, navigate]);

  // Calculate estimate for a single car type
  const calculateEstimateForCar = (car, route) => {
    if (!settings) return null;

    const distance = route.distance_in_km;
    const time = route.time_in_secs / 60; // in minutes

    let basePrice = car.base_fare || 0;
    let distancePrice = (car.rate_per_unit_distance || 0) * distance;
    let timePrice = (car.rate_per_hour || 0) * (time / 60);
    let minFare = car.min_fare || 0;

    let totalFare = basePrice + distancePrice + timePrice;
    if (totalFare < minFare) totalFare = minFare;

    // Add convenience fee if applicable
    if (car.convenience_fee_type && car.convenience_fees) {
      if (car.convenience_fee_type === 'flat') {
        totalFare += car.convenience_fees;
      } else {
        totalFare += (totalFare * car.convenience_fees / 100);
      }
    }

    return {
      car: car,
      fare: totalFare.toFixed(settings.decimal || 2),
      distance: distance.toFixed(1),
      duration: Math.round(time),
      eta: Math.round(Math.random() * 5 + 2) // Simulated ETA 2-7 min
    };
  };

  // Handle See Prices click
  const handleSeePrices = (e) => {
    e.preventDefault();

    if (!pickupAddress || !dropAddress) {
      setCommonAlert({ open: true, msg: t('select_proper') || 'Please enter pickup and destination' });
      return;
    }

    if (!userCombo && auth.profile.usertype !== 'customer') {
      setCommonAlert({ open: true, msg: t('select_user') || 'Please select a user' });
      return;
    }

    // Validate user profile
    if (settings?.imageIdApproval && auth.profile.usertype === 'customer' && !auth.profile.verifyId) {
      setCommonAlert({ open: true, msg: t('verifyid_error') });
      return;
    }

    if (auth.profile.usertype === 'customer' && parseFloat(auth.profile.walletBalance) < 0) {
      setCommonAlert({ open: true, msg: t('wallet_balance_low') });
      return;
    }

    setLoadingPrices(true);

    // Get route from Google Maps
    const directionService = new window.google.maps.DirectionsService();
    directionService.route(
      {
        origin: new window.google.maps.LatLng(pickupAddress.coords.lat, pickupAddress.coords.lng),
        destination: new window.google.maps.LatLng(dropAddress.coords.lat, dropAddress.coords.lng),
        travelMode: window.google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          const route = {
            distance_in_km: result.routes[0].legs[0].distance.value / 1000,
            time_in_secs: result.routes[0].legs[0].duration.value,
            polylinePoints: result.routes[0].overview_polyline
          };
          setTempRoute(route);

          // Calculate estimates for all car types
          if (cartypes && cartypes.length > 0) {
            const estimates = cartypes
              .sort((a, b) => a.pos - b.pos)
              .map(car => calculateEstimateForCar(car, route))
              .filter(est => est !== null);
            setCarEstimates(estimates);
            setShowCarOptions(true);
          }
          setLoadingPrices(false);
        } else {
          setCommonAlert({ open: true, msg: t('place_to_coords_error') || 'Could not calculate route' });
          setLoadingPrices(false);
        }
      }
    );
  };

  // Handle car selection
  const handleCarSelect = (estimate) => {
    const car = estimate.car;
    setSelectedCarDetails(car);

    let instObj = { ...instructionData };
    if (Array.isArray(car.parcelTypes)) {
      instObj.parcelTypeSelected = car.parcelTypes[0];
      instObj.parcelTypeIndex = 0;
    }
    if (Array.isArray(car.options)) {
      instObj.optionSelected = car.options[0];
      instObj.optionIndex = 0;
    }
    setInstructionData(instObj);

    // Check if car has options/parcel types that need selection
    if (Array.isArray(car.options) || Array.isArray(car.parcelTypes)) {
      setOptionModalStatus(true);
    } else {
      // Directly get estimate and show confirmation
      const estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: car,
        instructionData: instObj,
        routeDetails: tempRoute
      };
      dispatch(getEstimate(estimateRequest));
    }
  };

  // Watch for estimate data
  useEffect(() => {
    if (estimatedata.estimate && selectedCarDetails) {
      setEstimateModalStatus(true);
    }
  }, [estimatedata.estimate, selectedCarDetails]);

  const handleChange = (e) => {
    if (e.target.name === 'parcelTypeIndex') {
      setInstructionData({
        ...instructionData,
        parcelTypeIndex: parseInt(e.target.value),
        parcelTypeSelected: selectedCarDetails.parcelTypes[e.target.value]
      });
    } else if (e.target.name === 'optionIndex') {
      setInstructionData({
        ...instructionData,
        optionIndex: parseInt(e.target.value),
        optionSelected: selectedCarDetails.options[e.target.value]
      });
    } else if (e.target.name === 'payment_mode') {
      setPaymentMode(e.target.value);
    } else if (e.target.name === 'selectedProviderIndex') {
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    } else if (e.target.name === 'tripInstructions') {
      setTripInstructions(e.target.value);
    } else if (e.target.name === 'roundTrip') {
      setRoundTrip(e.target.value);
    } else {
      setInstructionData({ ...instructionData, [e.target.name]: e.target.value });
    }
  };

  const handleBookTypeSelect = (value) => {
    setBookingType(value);
    if (value === 'Book Now') {
      setSelectedDate(GetDateString());
    }
    setShowCarOptions(false);
    setCarEstimates([]);
  };

  const handleSwitchChange = (e) => {
    setInstructionData({ ...instructionData, [e.target.name]: e.target.checked });
  };

  const handleGetEstimate = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
    const estimateRequest = {
      pickup: pickupAddress,
      drop: dropAddress,
      carDetails: selectedCarDetails,
      instructionData: instructionData,
      routeDetails: tempRoute
    };
    dispatch(getEstimate(estimateRequest));
  };

  const clearForm = () => {
    setUserCombo(null);
    setPickupAddress(null);
    setDropAddress(null);
    setSelectedCarDetails(null);
    setBookingType('Book Now');
    setShowCarOptions(false);
    setCarEstimates([]);
    setPickupNote('');
    setTripInstructions('');
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    let requestedDrivers = {};
    let driverEstimates = {};

    let notfound = true;
    if (activeBookings) {
      for (let i = 0; i < activeBookings.length; i++) {
        if (activeBookings[i].payment_mode === 'wallet' && activeBookings[i].status !== 'PAID') {
          notfound = false;
          break;
        }
      }
    }

    if ((radioProps[payment_mode].cat === 'wallet' && notfound && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
      if ((radioProps[payment_mode].cat === 'wallet' && (parseFloat(auth.profile.walletBalance) >= parseFloat(estimatedata.estimate.estimateFare)) && !checkCat(3) && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || (radioProps[payment_mode].cat === 'wallet' && checkCat(3) && auth.profile.usertype === 'customer') || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
        if (settings.autoDispatch) {
          if (assignedDriverUid) {
            const chosen = drivers.find(d => d.uid === assignedDriverUid);
            if (chosen) {
              let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, chosen.location.lat, chosen.location.lng);
              if (settings.convert_to_mile) distance = distance / 1.609344;
              requestedDrivers[chosen.uid] = true;
              driverEstimates[chosen.uid] = { distance, timein_text: ((distance * 2) + 1).toFixed(0) + ' min' };
            }
          } else if (bookingType === 'Book Now') {
            for (let i = 0; i < drivers.length; i++) {
              const driver = drivers[i];
              let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
              if (settings.convert_to_mile) distance = distance / 1.609344;
              if (distance < (settings?.driverRadius || 10) && selectedCarDetails.name === driver.carType) {
                requestedDrivers[driver.uid] = true;
                driverEstimates[driver.uid] = { distance, timein_text: ((distance * 2) + 1).toFixed(0) + ' min' };
              }
            }
          }
        }

        const resolvedFleetAdmin = auth.profile.usertype === 'fleetadmin' ? auth.profile.uid : (partnerFleetId || null);
        let bookingObject = {
          pickup: pickupAddress,
          drop: dropAddress,
          carDetails: selectedCarDetails,
          userDetails: {
            uid: userCombo.uid,
            firstName: userCombo.firstName,
            lastName: userCombo.lastName,
            mobile: userCombo.mobile,
            pushToken: userCombo.pushToken,
            email: userCombo.email
          },
          estimate: estimatedata.estimate,
          instructionData: instructionData,
          tripInstructions: tripInstructions,
          roundTrip: roundTrip !== 0,
          tripdate: bookingType === 'Book Later' ? new Date(selectedDate).getTime() : new Date().getTime(),
          bookLater: bookingType === 'Book Later',
          settings: settings,
          booking_type_admin: auth.profile.usertype === 'admin',
          fleetadmin: resolvedFleetAdmin,
          requestedDrivers: requestedDrivers,
          driverEstimates: driverEstimates,
          payment_mode: (auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') ? 'cash' : radioProps[payment_mode].cat,
          booking_from_web: true
        };

        if (radioProps[payment_mode].cat === 'card') {
          bookingObject.paymentPacket = {
            payment_mode: 'card',
            customer_paid: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
            cardPaymentAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
            discount: 0,
            usedWalletMoney: 0,
            cashPaymentAmount: 0,
            promo_applied: false,
            promo_details: null,
            payableAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
          };
        }

        const result = validateBookingObj(t, bookingObject, instructionData);
        if (result.error) {
          setCommonAlert({ open: true, msg: result.msg });
        } else {
          setEstimateModalStatus(false);
          dispatch(addBooking(result.bookingObject));
        }
      } else {
        setCommonAlert({ open: true, msg: t('wallet_balance_low') });
      }
    } else {
      setCommonAlert({ open: true, msg: t('wallet_booking_alert') });
    }
  };

  const handleWalletPayment = (e) => {
    e.preventDefault();
    let curBooking = { ...bookingdata.booking.mainData };
    if (parseFloat(curBooking.trip_cost) > parseFloat(auth.profile.walletBalance) && radioProps[payment_mode].cat === 'wallet') {
      setCommonAlert({ open: true, msg: t('wallet_balance_low') });
    } else {
      let requestedDrivers = {};
      if (settings.autoDispatch && assignedDriverUid) {
        requestedDrivers[assignedDriverUid] = true;
      } else if (settings.autoDispatch && bookingType === 'Book Now') {
        for (let i = 0; i < drivers.length; i++) {
          const driver = drivers[i];
          let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
          if (settings.convert_to_mile) distance = distance / 1.609344;
          if (distance < (settings?.driverRadius || 10) && selectedCarDetails.name === driver.carType) {
            requestedDrivers[driver.uid] = true;
          }
        }
      }
      curBooking.prepaid = true;
      curBooking.status = 'NEW';
      curBooking.payment_mode = "wallet";
      curBooking.customer_paid = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = 0;
      curBooking.requestedDrivers = requestedDrivers;

      dispatch(updateBooking(curBooking));
      let walletBal = parseFloat(auth.profile.walletBalance) - parseFloat(curBooking.trip_cost);
      dispatch(updateWalletBalance(walletBal, { type: 'Debit', amount: curBooking.trip_cost, date: new Date().getTime(), txRef: curBooking.id }));

      setTimeout(() => {
        dispatch(clearEstimate());
        setPaymentModalStatus(false);
        setWalletModalStatus(false);
        clearForm();
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings');
      }, 1500);
    }
  };

  const handleOptionModalClose = (e) => { e.preventDefault(); setOptionModalStatus(false); };
  const handleEstimateModalClose = (e) => { e.preventDefault(); setEstimateModalStatus(false); dispatch(clearEstimate()); };
  const handleCommonAlertClose = (e) => { e.preventDefault(); setCommonAlert({ open: false, msg: '' }); };
  const handleWalletModalClose = () => { setTimeout(() => { setWalletModalStatus(false); dispatch(clearBooking()); dispatch(clearEstimate()); }, 1500); };
  const handlePaymentModalClose = () => { setTimeout(() => { setPaymentModalStatus(false); dispatch(clearBooking()); dispatch(clearEstimate()); }, 1500); };
  const handleBookingErrorClose = (e) => { e.preventDefault(); dispatch(clearBooking()); };
  const handleEstimateErrorClose = (e) => { e.preventDefault(); dispatch(clearEstimate()); };
  const handlePickupConfirmClose = () => { setPickupConfirmModalStatus(false); };

  // Open pickup confirmation modal
  const handleOpenPickupConfirm = () => {
    if (selectedCarDetails) {
      setPickupConfirmModalStatus(true);
    }
  };

  // Proceed from pickup confirmation to get estimate
  const handleConfirmPickup = () => {
    setPickupConfirmModalStatus(false);
    // Add pickup note to trip instructions if provided
    if (pickupNote.trim()) {
      setTripInstructions(prev => prev ? `${prev}\nPickup note: ${pickupNote}` : `Pickup note: ${pickupNote}`);
    }
    if (Array.isArray(selectedCarDetails?.options) || Array.isArray(selectedCarDetails?.parcelTypes)) {
      setOptionModalStatus(true);
    } else {
      const estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: selectedCarDetails,
        instructionData: instructionData,
        routeDetails: tempRoute
      };
      dispatch(getEstimate(estimateRequest));
    }
  };

  // Initialize map in pickup confirmation modal
  useEffect(() => {
    if (pickupConfirmModalStatus && pickupAddress && mapRef.current) {
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: pickupAddress.coords.lat, lng: pickupAddress.coords.lng },
        zoom: 16,
        disableDefaultUI: true,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: [
          { featureType: 'poi', stylers: [{ visibility: 'off' }] },
          { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        ],
      });

      // Add pickup marker
      new window.google.maps.Marker({
        position: { lat: pickupAddress.coords.lat, lng: pickupAddress.coords.lng },
        map: map,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: '#000',
          fillOpacity: 1,
          strokeColor: '#fff',
          strokeWeight: 3,
        },
      });
    }
  }, [pickupConfirmModalStatus, pickupAddress]);

  return (
    <Box
      ref={rootRef}
      sx={{ minHeight: 'calc(100vh - 100px)', bgcolor: '#fff', py: { xs: 4, md: 6 }, px: { xs: 2, md: 4 } }}
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Grid container spacing={4}>
          {/* Left Column - Booking Form */}
          <Grid item xs={12} md={6}>
            {settings?.country && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <FmdGoodOutlinedIcon sx={{ fontSize: 18, color: '#000' }} />
                <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#000' }}>{settings.country}</Typography>
              </Box>
            )}

            {activePartner ? (
              <Box sx={{ mb: 3, p: 2, borderRadius: 2, bgcolor: '#FFF7ED', border: '1px solid #FDBA74' }}>
                <Typography sx={{ fontWeight: 700, fontSize: 16, color: '#9A3412' }}>
                  Booking with {partnerDisplayName}
                </Typography>
                {activePartner.tagline || activePartner.description ? (
                  <Typography sx={{ fontSize: 14, color: '#9A3412', opacity: 0.85 }}>
                    {activePartner.tagline || activePartner.description}
                  </Typography>
                ) : null}
              </Box>
            ) : null}

            <Typography variant="h3" sx={{ fontWeight: 700, fontSize: { xs: 32, md: 44 }, color: '#000', mb: 4, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
              {t('request_ride') || 'Request a ride'}
            </Typography>

            {/* Pickup time selector */}
            <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
              <Box
                onClick={() => handleBookTypeSelect('Book Now')}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 1, px: 2.5, py: 1.5, borderRadius: 50,
                  bgcolor: bookingType === 'Book Now' ? '#000' : '#F3F4F6',
                  color: bookingType === 'Book Now' ? '#fff' : '#000',
                  cursor: 'pointer', transition: 'all 0.2s',
                  '&:hover': { bgcolor: bookingType === 'Book Now' ? '#1F2937' : '#E5E7EB' },
                }}
              >
                <AccessTimeIcon sx={{ fontSize: 18 }} />
                <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{t('pickup_now') || 'Pickup now'}</Typography>
                <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
              </Box>
              <Box
                onClick={() => handleBookTypeSelect('Book Later')}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 1, px: 2.5, py: 1.5, borderRadius: 50,
                  bgcolor: bookingType === 'Book Later' ? '#000' : '#F3F4F6',
                  color: bookingType === 'Book Later' ? '#fff' : '#000',
                  cursor: 'pointer', transition: 'all 0.2s',
                  '&:hover': { bgcolor: bookingType === 'Book Later' ? '#1F2937' : '#E5E7EB' },
                }}
              >
                <ScheduleOutlinedIcon sx={{ fontSize: 18 }} />
                <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{t('schedule') || 'Schedule'}</Typography>
              </Box>
            </Box>

            {bookingType === 'Book Later' && (
              <Box sx={{ mb: 3 }}>
                <TextField
                  type="datetime-local"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  fullWidth
                  sx={{
                    maxWidth: 300,
                    '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#F9FAFB', '& fieldset': { borderColor: '#E5E7EB' }, '&:hover fieldset': { borderColor: '#000' }, '&.Mui-focused fieldset': { borderColor: '#000', borderWidth: 2 } },
                  }}
                />
              </Box>
            )}

            {users && auth.profile.usertype && auth.profile.usertype !== 'customer' && (
              <Box sx={{ mb: 3 }}>
                <UsersCombo placeholder={t('select_user')} users={users} value={userCombo} onChange={(event, newValue) => setUserCombo(newValue)} />
              </Box>
            )}

            {/* Location inputs */}
            <Box sx={{ bgcolor: '#fff', border: '1px solid #E5E7EB', borderRadius: 3, p: 0, mb: 3, overflow: 'hidden' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2, py: 0.5, borderBottom: '1px solid #E5E7EB' }}>
                <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#000' }} />
                <Box sx={{ flex: 1 }}>
                  <GoogleMapsAutoComplete
                    variant="standard"
                    placeholder={t('enter_pickup') || 'Enter pickup location'}
                    value={pickupAddress}
                    onChange={(value) => { setPickupAddress(value); setShowCarOptions(false); }}
                  />
                </Box>
                <IconButton size="small" sx={{ color: '#6B7280' }}><MyLocationIcon sx={{ fontSize: 20 }} /></IconButton>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2, py: 0.5 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: 1, bgcolor: '#6B7280' }} />
                <Box sx={{ flex: 1 }}>
                  <GoogleMapsAutoComplete
                    variant="standard"
                    placeholder={t('enter_destination') || 'Enter destination'}
                    value={dropAddress}
                    onChange={(value) => { setDropAddress(value); setShowCarOptions(false); }}
                  />
                </Box>
              </Box>
            </Box>

            {/* See prices button */}
            <Button
              onClick={handleSeePrices}
              disabled={loadingPrices}
              fullWidth
              sx={{
                bgcolor: '#000', color: '#fff', py: 2, borderRadius: 2, fontSize: 16, fontWeight: 600,
                textTransform: 'none', boxShadow: 'none',
                '&:hover': { bgcolor: '#1F2937', boxShadow: 'none' },
                '&:disabled': { bgcolor: '#9CA3AF', color: '#fff' },
              }}
            >
              {loadingPrices ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : (t('see_prices') || 'See prices')}
            </Button>
          </Grid>

          {/* Right Column - Car Options */}
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#000', mb: 3 }}>
              {showCarOptions ? (t('choose_ride') || 'Choose a ride') : (t('suggestions') || 'Suggestions')}
            </Typography>

            {!showCarOptions ? (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Box sx={{ border: '1px solid #E5E7EB', borderRadius: 3, p: 3, textAlign: 'center', cursor: 'pointer', transition: 'all 0.2s', '&:hover': { borderColor: '#000', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' } }}>
                    <Box sx={{ width: 64, height: 64, mx: 'auto', mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img src="https://d1a3f4spazzrp4.cloudfront.net/car-types/haloProductImages/v1.1/UberX_v1.png" alt="Ride" style={{ height: 48 }} onError={(e) => { e.target.style.display = 'none'; }} />
                    </Box>
                    <Typography sx={{ fontWeight: 600, color: '#000' }}>{t('ride') || 'Ride'}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    onClick={() => handleBookTypeSelect('Book Later')}
                    sx={{ border: '1px solid #E5E7EB', borderRadius: 3, p: 3, textAlign: 'center', cursor: 'pointer', transition: 'all 0.2s', bgcolor: bookingType === 'Book Later' ? '#F9FAFB' : 'transparent', '&:hover': { borderColor: '#000', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' } }}
                  >
                    <Box sx={{ width: 64, height: 64, mx: 'auto', mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <ScheduleOutlinedIcon sx={{ fontSize: 48, color: '#000' }} />
                    </Box>
                    <Typography sx={{ fontWeight: 600, color: '#000' }}>{t('reserve') || 'Reserve'}</Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Box>
                {/* Car options list */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, mb: 3 }}>
                  {carEstimates.map((est, idx) => {
                    const isSelected = selectedCarDetails?.name === est.car.name;
                    const arrivalTime = new Date(Date.now() + est.eta * 60000);
                    const arrivalStr = arrivalTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                    return (
                      <Box
                        key={idx}
                        onClick={() => handleCarSelect(est)}
                        sx={{
                          display: 'flex', alignItems: 'center', gap: 2, p: 2,
                          borderRadius: isSelected ? 3 : 0,
                          border: isSelected ? '2px solid #000' : 'none',
                          borderBottom: !isSelected ? '1px solid #F3F4F6' : 'none',
                          bgcolor: isSelected ? '#fff' : 'transparent',
                          cursor: 'pointer', transition: 'all 0.15s',
                          mx: isSelected ? 0 : 0,
                          my: isSelected ? 1 : 0,
                          '&:hover': { bgcolor: '#F9FAFB' },
                        }}
                      >
                        {/* Car Image */}
                        <Box sx={{ width: 72, height: 45, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <img src={est.car.image} alt={est.car.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                        </Box>

                        {/* Car Info */}
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Typography sx={{ fontWeight: 600, fontSize: 16, color: '#000' }}>{est.car.name}</Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#6B7280' }}>
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
                              <Typography sx={{ fontSize: 13 }}>{est.car.seats || 4}</Typography>
                            </Box>
                            {idx === 0 && (
                              <Box sx={{ bgcolor: '#22C55E', color: '#fff', px: 1, py: 0.25, borderRadius: 1, fontSize: 11, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <span>⚡</span> {t('faster') || 'Faster'}
                              </Box>
                            )}
                          </Box>
                          <Typography sx={{ fontSize: 13, color: '#6B7280' }}>
                            {est.eta} mins away • {arrivalStr}
                          </Typography>
                          {est.car.desc && (
                            <Typography sx={{ fontSize: 12, color: '#9CA3AF', mt: 0.25 }}>
                              {est.car.desc}
                            </Typography>
                          )}
                        </Box>

                        {/* Price */}
                        <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
                          <Typography sx={{ fontWeight: 600, fontSize: 16, color: '#000' }}>
                            {settings?.swipe_symbol === false ? settings?.symbol : ''}{est.fare}{settings?.swipe_symbol !== false ? ' ' + settings?.symbol : ''}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>

                {/* Payment method selector */}
                {auth.profile.usertype === 'customer' && (
                  <Box
                    sx={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      p: 2, borderRadius: 2, border: '1px solid #E5E7EB', mb: 2, cursor: 'pointer',
                      '&:hover': { bgcolor: '#F9FAFB' },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#F3F4F6', p: 1, borderRadius: 1 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="#000"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
                        <Box sx={{ width: 16, height: 12, bgcolor: '#000', borderRadius: 0.5 }} />
                      </Box>
                      <Box>
                        <Typography sx={{ fontWeight: 500, fontSize: 15, color: '#000' }}>{t('personal') || 'Personal'}</Typography>
                        <Typography sx={{ fontSize: 13, color: '#6B7280' }}>
                          {radioProps[payment_mode]?.label || t('wallet')}
                        </Typography>
                      </Box>
                    </Box>
                    <KeyboardArrowDownIcon sx={{ color: '#6B7280', transform: 'rotate(-90deg)' }} />
                  </Box>
                )}

                {/* Request button */}
                {selectedCarDetails && (
                  <Button
                    onClick={handleOpenPickupConfirm}
                    fullWidth
                    sx={{
                      bgcolor: '#000', color: '#fff', py: 2, borderRadius: 2, fontSize: 16, fontWeight: 600,
                      textTransform: 'none', boxShadow: 'none',
                      '&:hover': { bgcolor: '#1F2937', boxShadow: 'none' },
                    }}
                  >
                    {t('request') || 'Request'} {selectedCarDetails.name}
                  </Button>
                )}
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>

      {/* Pickup Confirmation Modal */}
      <Modal open={pickupConfirmModalStatus} onClose={handlePickupConfirmClose} className={classes.modal} container={() => rootRef.current}>
        <Box sx={{
          width: 420,
          maxWidth: '95vw',
          bgcolor: '#fff',
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 25px 50px rgba(0,0,0,0.15)',
        }}>
          {/* Map area */}
          <Box sx={{ position: 'relative', height: 220, bgcolor: '#E5E7EB' }}>
            <Box ref={mapRef} sx={{ width: '100%', height: '100%' }} />
            {/* Back button */}
            <IconButton
              onClick={handlePickupConfirmClose}
              sx={{
                position: 'absolute',
                top: 12,
                left: 12,
                bgcolor: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                '&:hover': { bgcolor: '#F9FAFB' },
              }}
            >
              <ArrowBackIcon sx={{ fontSize: 20, color: '#000' }} />
            </IconButton>
          </Box>

          {/* Content */}
          <Box sx={{ p: 3 }}>
            <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#000', mb: 3 }}>
              {t('confirm_pickup_location') || 'Confirm the pick-up location'}
            </Typography>

            {/* Location display */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2,
                bgcolor: '#F9FAFB',
                borderRadius: 2,
                mb: 2,
              }}
            >
              <Box sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <SearchIcon sx={{ fontSize: 20, color: '#6B7280' }} />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#000', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {pickupAddress?.description?.split(',')[0] || t('pickup_location')}
                </Typography>
                <Typography sx={{ fontSize: 13, color: '#6B7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {pickupAddress?.description || ''}
                </Typography>
              </Box>
            </Box>

            {/* Pickup note input */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2,
                border: '1px solid #E5E7EB',
                borderRadius: 2,
                mb: 3,
                cursor: 'text',
              }}
            >
              <Box sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                bgcolor: '#000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#fff' }}>P</Typography>
              </Box>
              <TextField
                variant="standard"
                placeholder={t('add_pickup_note') || 'Add pickup note for driver'}
                value={pickupNote}
                onChange={(e) => setPickupNote(e.target.value)}
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  sx: { fontSize: 14, color: '#000' },
                }}
                sx={{ '& .MuiInputBase-input::placeholder': { color: '#6B7280', opacity: 1 } }}
              />
            </Box>

            {/* Confirm button */}
            <Button
              onClick={handleConfirmPickup}
              fullWidth
              sx={{
                bgcolor: '#000',
                color: '#fff',
                py: 2,
                borderRadius: 2,
                fontSize: 16,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: 'none',
                '&:hover': { bgcolor: '#1F2937', boxShadow: 'none' },
              }}
            >
              {t('confirm_and_request') || 'Confirm and request'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Options Modal */}
      <Modal open={optionModalStatus} onClose={handleOptionModalClose} className={classes.modal} container={() => rootRef.current}>
        <Box className={classes.paper}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{t('ride_options') || 'Ride options'}</Typography>
            <IconButton onClick={handleOptionModalClose} size="small"><CloseIcon /></IconButton>
          </Box>
          {selectedCarDetails?.parcelTypes && (
            <Box sx={{ mb: 3 }}>
              <FormControl component="fieldset">
                <FormLabel sx={{ fontWeight: 600, color: '#000', mb: 1 }}>{t('parcel_types')}</FormLabel>
                <RadioGroup name="parcelTypeIndex" value={instructionData.parcelTypeIndex} onChange={handleChange}>
                  {selectedCarDetails.parcelTypes.map((el, idx) => (
                    <FormControlLabel key={el.description} value={idx} control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />}
                      label={settings.swipe_symbol === false ? settings.symbol + ' ' + el.amount + ' - ' + el.description : el.amount + ' ' + settings.symbol + ' - ' + el.description} />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          )}
          {selectedCarDetails?.options && (
            <Box sx={{ mb: 3 }}>
              <FormControl component="fieldset">
                <FormLabel sx={{ fontWeight: 600, color: '#000', mb: 1 }}>{t('options')}</FormLabel>
                <RadioGroup name="optionIndex" value={instructionData.optionIndex} onChange={handleChange}>
                  {selectedCarDetails.options.map((el, idx) => (
                    <FormControlLabel key={el.description} value={idx} control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />}
                      label={settings.swipe_symbol === false ? settings.symbol + ' ' + el.amount + ' - ' + el.description : el.amount + ' ' + settings.symbol + ' - ' + el.description} />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          )}
          <FormControlLabel control={<Switch checked={instructionData.carrySelected} onChange={handleSwitchChange} name="carrySelected" />} label={t('carryText')} sx={{ mb: 3 }} />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button onClick={handleOptionModalClose} fullWidth sx={{ bgcolor: '#F3F4F6', color: '#000', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: '#E5E7EB' } }}>{t('cancel')}</Button>
            <Button onClick={handleGetEstimate} fullWidth sx={{ bgcolor: '#000', color: '#fff', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: '#1F2937' } }}>{t('continue') || 'Continue'}</Button>
          </Box>
        </Box>
      </Modal>

      {/* Estimate/Confirm Modal */}
      <Modal open={estimateModalStatus} onClose={handleEstimateModalClose} className={classes.modal} container={() => rootRef.current}>
        <Box className={classes.paper} sx={{ maxWidth: 520 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography sx={{ fontSize: 24, fontWeight: 700 }}>{t('confirm_ride') || 'Confirm your ride'}</Typography>
            <IconButton onClick={handleEstimateModalClose} size="small"><CloseIcon /></IconButton>
          </Box>
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1, p: 2, bgcolor: '#F9FAFB', borderRadius: 2 }}>
                <Typography sx={{ fontSize: 12, color: '#6B7280', mb: 0.5 }}>{t('from') || 'From'}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#000' }}>{pickupAddress?.description || '-'}</Typography>
              </Box>
              <Box sx={{ flex: 1, p: 2, bgcolor: '#F9FAFB', borderRadius: 2 }}>
                <Typography sx={{ fontSize: 12, color: '#6B7280', mb: 0.5 }}>{t('to') || 'To'}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#000' }}>{dropAddress?.description || '-'}</Typography>
              </Box>
            </Box>
            {estimatedata?.estimate && (
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ p: 2, bgcolor: '#F9FAFB', borderRadius: 2, flex: 1, minWidth: 100 }}>
                  <Typography sx={{ fontSize: 12, color: '#6B7280' }}>{t('distance') || 'Distance'}</Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#000' }}>{estimatedata.estimate.distance} {settings?.convert_to_mile ? 'mi' : 'km'}</Typography>
                </Box>
                <Box sx={{ p: 2, bgcolor: '#F9FAFB', borderRadius: 2, flex: 1, minWidth: 100 }}>
                  <Typography sx={{ fontSize: 12, color: '#6B7280' }}>{t('time') || 'Time'}</Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#000' }}>{estimatedata.estimate.estimateTime}</Typography>
                </Box>
                <Box sx={{ p: 2, bgcolor: '#000', borderRadius: 2, flex: 1, minWidth: 100 }}>
                  <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>{t('fare') || 'Fare'}</Typography>
                  <Typography sx={{ fontSize: 24, fontWeight: 700, color: '#fff' }}>
                    {settings?.swipe_symbol === false ? settings?.symbol + estimatedata.estimate.estimateFare : estimatedata.estimate.estimateFare + settings?.symbol}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
          <BookingModalBody classes={classes} instructionData={instructionData} handleChange={handleChange} tripInstructions={tripInstructions} roundTrip={roundTrip} />
          {auth.profile.usertype === 'customer' && (
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1.5 }}>{t('payment_mode')}</Typography>
              <RadioGroup name="payment_mode" value={payment_mode} onChange={handleChange} row>
                {radioProps.map((el, idx) => (
                  <FormControlLabel key={el.cat} value={idx} control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label={el.label} />
                ))}
              </RadioGroup>
            </Box>
          )}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button onClick={handleEstimateModalClose} fullWidth sx={{ bgcolor: '#F3F4F6', color: '#000', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: '#E5E7EB' } }}>{t('cancel')}</Button>
            <Button onClick={confirmBooking} fullWidth sx={{ bgcolor: '#000', color: '#fff', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: '#1F2937' } }}>{t('confirm_booking') || 'Confirm booking'}</Button>
          </Box>
        </Box>
      </Modal>

      {/* Wallet Modal */}
      <Modal open={walletModalStatus} onClose={handleWalletModalClose} className={classes.modal} container={() => rootRef.current}>
        <Box className={classes.paper}>
          <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 2 }}>{t('payment')}</Typography>
          {bookingdata?.booking && (
            <Typography sx={{ fontSize: 36, fontWeight: 700, color: '#000', mb: 1 }}>
              {settings?.swipe_symbol === false ? settings?.symbol + bookingdata.booking.mainData.trip_cost : bookingdata.booking.mainData.trip_cost + settings?.symbol}
            </Typography>
          )}
          <Typography sx={{ color: '#6B7280', mb: 3 }}>
            {t('use_wallet_balance')} ({settings?.swipe_symbol === false ? settings?.symbol + auth.profile.walletBalance : auth.profile.walletBalance + settings?.symbol})
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button onClick={handleWalletModalClose} fullWidth sx={{ bgcolor: '#F3F4F6', color: '#000', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none' }}>{t('cancel')}</Button>
            <Button onClick={handleWalletPayment} fullWidth sx={{ bgcolor: '#000', color: '#fff', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none' }}>{t('paynow_button')}</Button>
          </Box>
        </Box>
      </Modal>

      {/* Card Payment Modal */}
      <Modal open={paymentModalStatus} onClose={handlePaymentModalClose} className={classes.modal} container={() => rootRef.current}>
        <Box className={classes.paper}>
          {providers && selectedProvider && bookingdata?.booking && (
            <form action={selectedProvider.link} method="POST">
              <input type="hidden" name="order_id" value={bookingdata.booking.booking_id} />
              <input type="hidden" name="amount" value={bookingdata.booking.mainData.trip_cost} />
              <input type="hidden" name="currency" value={settings?.code} />
              <input type="hidden" name="product_name" value={t('bookingPayment')} />
              <input type="hidden" name="first_name" value={auth.profile.firstName} />
              <input type="hidden" name="last_name" value={auth.profile.lastName} />
              <input type="hidden" name="quantity" value={1} />
              <input type="hidden" name="cust_id" value={bookingdata.booking.mainData.customer} />
              <input type="hidden" name="mobile_no" value={bookingdata.booking.mainData.customer_contact} />
              <input type="hidden" name="email" value={bookingdata.booking.mainData.customer_email} />
              <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 3 }}>{t('payment')}</Typography>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <Select value={selectedProviderIndex} name="selectedProviderIndex" onChange={handleChange} sx={{ borderRadius: 2 }}>
                  {providers.map((provider, index) => (
                    <MenuItem key={provider.name} value={index}><img src={icons[provider.name]} alt={provider.name} style={{ height: 24, margin: 7 }} /></MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button onClick={handlePaymentModalClose} fullWidth sx={{ bgcolor: '#F3F4F6', color: '#000', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none' }}>{t('cancel')}</Button>
                <Button type="submit" onClick={handlePaymentModalClose} fullWidth sx={{ bgcolor: '#000', color: '#fff', py: 1.5, borderRadius: 2, fontWeight: 600, textTransform: 'none' }}>{t('paynow_button')}</Button>
              </Box>
            </form>
          )}
        </Box>
      </Modal>

      <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
      <AlertDialog open={estimatedata.error.flag} onClose={handleEstimateErrorClose}>{estimatedata.error.msg}</AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </Box>
  );
}
